import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
// import React from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  clearPostBudgetResponse,
  setEditedBudgets,
} from "../../../../../features/engagementIncentivesSlice";

const ResponseDialog = () => {
  const postResponse = useSelector(
    (state: any) => state.engagementIncentives?.postBudgetResponse
  );
  const editedBudgets = useSelector(
    (state: any) => state.engagementIncentives?.editedBudgets
  );
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(clearPostBudgetResponse());
    dispatch(setEditedBudgets([]));
  };

  if (!postResponse) return null;

  const { responseData, creationStatus } = postResponse;

  const getMessage = () => {
    switch (creationStatus) {
      case "all":
        return "All budgets created successfully.";
      case "some":
        return "Some budgets were created. See the table for details.";
      case "none":
        return "No budgets were created. See the table for failure reasons.";
      default:
        return "Unknown status.";
    }
  };
  const getBrandName = (uid: string) => {
    const brand = editedBudgets.find((budget: any) => {
      // Log the UID being compared
      return budget.brand_shared_uid === uid;
    });
    return brand ? brand.brand_name : "Unknown Brand";
  };
  return (
    <Dialog
      open={Boolean(postResponse)}
      //   open
      maxWidth="md"
      fullWidth
      onClose={handleClose}
    >
      <DialogTitle>Duplication Result</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>{getMessage()}</DialogContentText>
        {creationStatus === "some" && (
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Brand Name</TableCell>
                <TableCell>Created</TableCell>
                <TableCell>Reason</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {responseData?.map((row: any, index: number) => (
                <TableRow key={index}>
                  <TableCell>{getBrandName(row.brand_shared_uid)}</TableCell>
                  <TableCell>{row.created ? "Yes" : "No"}</TableCell>
                  <TableCell>{row.reason || "N/A"}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant="contained" color="secondary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default ResponseDialog;
